// console.log(`video-gallery.js is working`);

const videoGallery = document.querySelector(`.video-gallery`);

if (videoGallery) {
  const videoThumbnail = document.querySelectorAll(`.video-thumbnail`);
  const videoContainer = document.querySelector(`.video-container`);
  const videoWrapper = document.querySelector(`.video-wrapper`);

  const videoPlayer = document.querySelector(`#video-player`);
  const videoPlayerSource = document.querySelector(
    `.video-player-container video source`
  );

  const setInitVideo = () => {
    const initialThumbail = videoThumbnail[0];
    initialThumbail.classList.add(`active-video`);
    videoContainer.style = `--video-gallery-thumbnail-slider-height: ${videoWrapper.offsetHeight}px`;
    videoPlayerSource.src = videoThumbnail[0].firstElementChild.src;
    videoPlayer.load();
    videoPlayerDetails(initialThumbail);
  };

  const videoPlayerDetails = (thumb) => {
    videoPlayer.onloadedmetadata = () => {
      const details = thumb.querySelector(`.thumbnail-video-details`);
      let newDetails = details.children[0].innerText;
      const videoDetails = document.querySelector(`.video-details`);
      videoDetails.children[0].innerHTML = newDetails;
    };
  };

  const selectVideo = (thumbnail) => {
    thumbnail.classList.add(`active-video`);
    videoPlayerSource.src = thumbnail.firstElementChild.src;
    videoPlayer.load();
    videoPlayerDetails(thumbnail);
  };

  const removeClasses = () => {
    videoThumbnail.forEach((thumbnail) => {
      thumbnail.classList.remove(`active-video`);
    });
  };

  videoThumbnail.forEach((thumbnail, i) => {
    if (thumbnail[i] === 0) {
      thumbnail[0].classlist.add(`active-video`);
    }
    thumbnail.addEventListener(`click`, (e) => {
      removeClasses();
      selectVideo(thumbnail);
      e.preventDefault();
    });
    thumbnail.addEventListener(`touchend`, (e) => {
      videoContainer.scrollIntoView({ behavior: `smooth` });
      removeClasses();
      selectVideo(thumbnail);
      e.preventDefault();
    });
  });

  setInitVideo();
}
